import type { IRMetricKey } from '~/presentation/reports/common/type';
import type { ReportRowType } from '../types';

import {
  COLUMN_SEPARATOR,
  COMPARISON_PREFIX,
  DIMENSION_SEPARATOR,
  PREVIOUS_PERIOD_KEY,
  TOTAL_SUFFIX,
} from '../constants';

const joinColumnParts = (...parts: string[]) => parts.join(COLUMN_SEPARATOR);
const getDimensionPathKey = (dimensions: string[], dimensionIndex: number) =>
  dimensions.slice(0, dimensionIndex + 1).join(DIMENSION_SEPARATOR);

export function getPreviousColumnName(key: IRMetricKey | string) {
  return joinColumnParts(COMPARISON_PREFIX, key, PREVIOUS_PERIOD_KEY);
}

export function getPreviousTotalColumnName(key: IRMetricKey | string) {
  return joinColumnParts(COMPARISON_PREFIX, key, PREVIOUS_PERIOD_KEY, TOTAL_SUFFIX);
}

export function getTotalColumnName(key: IRMetricKey | string) {
  return joinColumnParts(key, TOTAL_SUFFIX);
}

export function getTotalColumnNameByDimensions(
  dimensions: string[],
  key: string,
  dimensionIndex: number,
) {
  return joinColumnParts(key, getDimensionPathKey(dimensions, dimensionIndex), TOTAL_SUFFIX);
}

export function getPreviousTotalColumnNameByDimensions(
  dimensions: string[],
  key: string,
  dimensionIndex: number,
) {
  return joinColumnParts(
    COMPARISON_PREFIX,
    key,
    PREVIOUS_PERIOD_KEY,
    getDimensionPathKey(dimensions, dimensionIndex),
    TOTAL_SUFFIX,
  );
}

export function getMetricValue(row: ReportRowType, key: IRMetricKey | string) {
  return row[key] || 0;
}

export function getMetricPreviousValue(row: ReportRowType, key: IRMetricKey | string) {
  return row[getPreviousColumnName(key)];
}

export function getMetricTotalValue(row: ReportRowType, key: IRMetricKey | string) {
  return Number(row[getTotalColumnName(key)]) || 0;
}

export function getMetricPreviousTotalValue(row: ReportRowType, key: IRMetricKey | string) {
  return Number(row[getPreviousTotalColumnName(key)]) || 0;
}

export const isMainColumn = (columnName: string) => !columnName.includes(COLUMN_SEPARATOR);
